import React from 'react';

let colorScheme: any;
const ChangeThemeContext = React.createContext(colorScheme);

export default ChangeThemeContext;

